import Accordion from '@components/Accordion';
import Column from '@components/Column';
import Divider from '@components/Divider';
import Header from '@components/Header';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import PointHeader from './components/PointHeader';
import PointLogs from './components/PointLogs';

const PointActivity: ActivityComponentType = () => (
        <AppScreen>
            <Column fullWidth>
                <Header title='포인트 적립'/>
                <PointHeader/>
                <PointLogs/>
                <Divider/>
                <Accordion title='유의사항'/>
            </Column>
        </AppScreen>
);

export default PointActivity;
